import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { BoxTitle } from './common';
import { campaign as actions } from '../../redux/actions';

const BoxSubTitle = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none;
  }


  all: initial;
  color: #0086C2;
  font-weight: bold !important;
  font-size: 16px !important;
  text-decoration: none;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  padding-bottom: 3px;

  &:hover{
    color: #11A9CE;
    border-bottom: 1px solid #11A9CE;
    padding-bottom: 3px;
  }
`;

const SubTitleText = styled.span`
  padding-bottom: 3px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const Container = styled.div`
  background-color: #e9f7f6;
  border: 0 !important;
  &::-moz-focus-inner {
    border: 0;
  }
  border-radius: 10px;
  position: relative;
  padding: 15px;
  box-shadow: 0 0 11px 0px #ccc;
  margin-right: 25px;
  padding-right: 20px;
  margin-bottom: 24px;
`;

const PlayCampaign = styled.button`
  all: initial;
  border: none;
  cursor: pointer;

  &:before,
  &:after{
    content: '';
    position: absolute;
  }

  &:before{
    background-color: #2886c2;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    top: 0;
    bottom: 0;
    margin: auto;
    right: -25px;
  }

  &:after{
    top: 0;
    bottom: 0;
    margin: auto;
    border-left: 16px solid white;
    border-right: 5px solid transparent;
    width: 0;
    height: 0;
    border-top: 11px solid transparent;
    border-bottom: 11px solid transparent;
    right: -16px;
  }
`;

const Campaign = ({
  triggerCampaign,
  campaignInfo
}) => {
  const activateCampaign = () => {
    triggerCampaign(true);
  };

  return (
    <Container tabIndex="-1">
      <BoxTitle tabIndex="-1">
        {'What\'s on this month?'}
      </BoxTitle>
      <BoxSubTitle tabIndex="0" onClick={activateCampaign}>
        <SubTitleText tabIndex="-1">
          {campaignInfo.campaign_nm || ''}
        </SubTitleText>
      </BoxSubTitle>
      <PlayCampaign tabIndex="-1" onClick={activateCampaign} />
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  triggerCampaign: (active) => dispatch(actions.triggerCampaign(active))
});

export default connect((state) => ({
  projectId: state.app.projectId,
  districtId: state.app.districtId,
  uuid: state.app.uuid,
  lang: state.config.lang,
  campaignInfo: state.campaign.campaignInfo
}), mapDispatchToProps)(Campaign);
